// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import { gql } from '@apollo/client';
import { useMutation } from '@ion/api';
import permissions from '@ion/api/Apollo/permissions';
import { useUserContext } from '@ion/user';

const mutation = gql`
  mutation BuildAjsFile($settingsJson: jsonb!) {
    build_ajs_file(settingsJson: $settingsJson) {
      status
      data
    }
  }
`;

export default function useBuildAjsFileNoAudit(options = {}) {
  const { currentOrg } = useUserContext();
  const [executeMutation, response] = useMutation(mutation, {
    ...options,
    context: { permission: permissions.updatePipelineAJSBuilder },
  });

  const buildAjsFileMutation = ({ settingsJson }) => {
    settingsJson.clientName = currentOrg.name;
    return executeMutation({
      variables: { settingsJson },
    });
  };

  return [buildAjsFileMutation, response];
}
